<template>
  <div class="import-tool">
    <Modal v-model="visible" title="跟进" :mask-closable="false" width="770" :footer-hide="true" class="my-modal top import-tool-modal2">
      <Form ref="form" :model="form" :label-width="92" class="modal-form" :rules="ruleInline">   
        <div class="form-item">
          <div class="item">
            <FormItem prop="chatDate" label="沟通时间" :rules="$units.formRule.objRequired('请选择')">
              <DatePicker
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                split-panels
                v-model="form.chatDate"
                placeholder="请选择"
                style="width:100%;"
              ></DatePicker>
            </FormItem>
          </div>

          <div class="item">
            <FormItem prop="status" label="跟进状态">
              <Select clearable v-model="form.status">
                <Option
                  :value="item.value"
                  v-for="(item, index) in followUpStatusList"
                  :key="index"
                  >{{ item.txt }}</Option
                >
              </Select>
            </FormItem>
          </div>    
        </div>

        <div class="form-item">
          <div class="item">
            <FormItem prop="chatTime" label="沟通时长(分钟)">
              <Input v-model="form.chatTime" placeholder="请输入" @on-change="durationLimit" type="number" clearable />
            </FormItem>
          </div>

          <div class="item">
            <FormItem prop="type" label="沟通方式">
              <Select clearable v-model="form.type">
                <Option
                  :value="item.value"
                  v-for="(item, index) in communicateTypeList"
                  :key="index"
                  >{{ item.txt }}</Option
                >
              </Select>
            </FormItem>
          </div>          
        </div>

        <FormItem prop="content" label="沟通内容">
          <Input v-model="form.content" placeholder="请输入" type="textarea" show-word-limit :maxlength="150" :clearable="true" />
        </FormItem>

        <FormItem prop="nextChatDate" label="下次沟通时间">
          <DatePicker
            :options="disableTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            split-panels
            v-model="form.nextChatDate"
            placeholder="设置后系统发送提醒"
            style="width:100%;"
          ></DatePicker>
        </FormItem>

        <div class="form-item">
          <div class="item">
            <FormItem prop="nextType" label="下次沟通方式">
              <Select clearable v-model="form.nextType">
                <Option
                  :value="item.value"
                  v-for="(item, index) in communicateTypeList"
                  :key="index"
                  >{{ item.txt }}</Option
                >
              </Select>
            </FormItem>
          </div>
        </div>        

        <FormItem label="上传录音">
          <Upload action :before-upload="uploadExecl" v-if="!uploading&&!form.record.name">
            <div class="download-button">
              <a>上传</a>
            </div>
          </Upload>
          <div class="upload-box" v-else>
            <div class="file-time">
              <span>{{ this.form.record.name }}</span>
              <img @click="deleteRecording" src="@/assets/images/icon/org/cancel-icon.png" v-if="uploadText=='上传成功!'">          
            </div>
            <div class="proress">
              <Progress style="width:400px;" :stroke-width="4" :percent="progress" :hide-info="true" />
              <span class="upload-text" :style="{color:uploadText=='上传成功!'?'#35BF3F':'#236DFF'}">{{ uploadText }}</span>
            </div>
          </div>
        </FormItem>

        <div class="submit-box">
          <a @click="visible=false"><div class="cancel">取消</div></a>
          <a  @click="ok"><div class="confirm">确认</div></a>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { getFollowUpStatusList, getCommunicateType, upLoadFile } from '../../form/api';
import filters from "@/api/filter";

export default {
  props:['getInsureList'],
  data() {
    return {
      visible:false,
      form:{
        chatDate:'',
        status:'',
        chatTime:'',
        type:'',
        content:'',
        nextChatDate:'',
        nextType:'',
        record:''
      },
      disableTime:{
        disabledDate (date) {
            return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      followUpStatusList:[],//跟进状态
      communicateTypeList:[],//沟通方式
      ruleInline:{
        status: [
          {
            required: true,
            message: "请选择跟进状态",
            trigger: "change",
          },
        ],
      },
      uploading:false,
      uploadText:'',
      progress:0,
      uploadFileName:''
    };
  },

  methods: {
    open(data){ 
      this.form = JSON.parse(JSON.stringify(data));
      this.form.record = JSON.parse(this.form.record);
      this.form.agentId = JSON.parse(localStorage.getItem('userInfo')).userid;
      this.queryFollowUpStatus();
      this.queryCommunicateType();
      if(this.form.record){
        this.uploadText = '上传成功!';
        this.progress = 100;
      }
      this.visible = true;
    },

    // 跟进状态
    async queryFollowUpStatus() {
      const { data } = await getFollowUpStatusList();
      this.followUpStatusList = data.filter(item=>item.value !='-1');
    },

    // 沟通方式
    async queryCommunicateType() {
      const { data } = await getCommunicateType();
      this.communicateTypeList = data;
    },

    // 上传Excel
    uploadExecl(file) {
      if (!/\.(mp3)$/.test(file.name.toLowerCase())) {
        this.$Message.error("请上传格式为音频的文件！");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      upLoadFile(formData, (e)=>{
        console.log(this.form)
        this.form.record.name = file.name;
        this.uploading = true;
        this.uploadText = '正在上传……'
        this.progress = e.loaded/e.total*100;
      }).then(res=>{
        this.form.record.url = res.data[0].path;
        this.uploadText = '上传成功!';
      }).catch(() => {
        this.deleteRecording();
      });
      return false;
    },

    // 删除上传录音
    deleteRecording() {
      this.uploading = false;
      this.uploadText = '';
      this.progress = 0;
      this.form.record = {};
    },

    // 时长设置
    durationLimit() {
      if(this.form.chatTime.length>10) {
        this.form.chatTime=this.form.chatTime.toString().substr(0,9);
      }
    },

    // 提交
    ok() {
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        this.submit();
      });
    },

    submit() {
      let form = this.form;
      form.chatDate = form.chatDate ? filters.filterTime(form.chatDate, "YYYY-MM-DD HH:mm") : "";//沟通时间
      if(form.nextChatDate){
        form.nextChatDate = form.nextChatDate ? filters.filterTime(form.nextChatDate, "YYYY-MM-DD HH:mm") : "";//下次沟通时间          
      }
      for(let  key in form) {
        if(!form[key]){
          form[key] = '';
        }
      }
      this.$http({
        url: `/buz/customerFollowRecord/edit`,
        type: "POST",
        data:form,
      }).then((res) => {
        this.$notice.success("修改成功");        
        this.getInsureList();
        this.visible = false;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-body {
    padding-bottom: 40px;
  }
  .ivu-modal-header-inner{
    font-size: 14px;
    font-weight: bold;
    color: #3C464F;
  }
  .ivu-modal-close{
    top: 4px ;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #A8ADB7;
    }
  }
  .ivu-modal-header{
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
}

/deep/ .ivu-form-item-label {
  color: #515C6F;
  font-size: 12px;
}

.form-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .item {
    width: 49%;
    .ivu-select-item {
      font-size: 12px !important;
    }
    /deep/ .ivu-select-placeholder{
      font-size: 12px !important;
    }
  }
}

.upload-box {
  width: 460px;
  .file-time {
    display: flex;
    align-items: center;
    span {
      font-size: 12px;
      color: #727C8E;
    }
    img {
      width: 12px;
      height: 12px;
      margin-left: 10px;
    }
  }
  .proress {
    position: relative;
    display: flex;
    align-items: center;
    /deep/ .ivu-progress-outer {
      height: 4px;
      position: relative;
    }
    /deep/ .ivu-progress-inner {
      height: 4px;
      position: absolute;
      top: -15px;
      width: 380px;
    }
    .upload-text {
      font-size: 12px;
      color: #236DFF;
      position: absolute;
      top: -13px;
      right: 0;
    }
  }
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  width: 64px;
  height: 26px;
  color: #236DFF;
  font-size: 12px;
  background-color: #F2F6FF;
}

.submit-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 220px;
  height: 30px;
  margin: 0 auto;
  .cancel {
    border: 1px solid #236DFF;
    border-radius: 2px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #236DFF;
    font-size: 12px;
  }
  .confirm {
    background: #236DFF;
    border-radius: 2px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
</style>
